var map = {
	"./default.json": 57156,
	"./hk_agency.json": 1623,
	"./hk_banker.json": 23558,
	"./hk_borker.json": 16376,
	"./mo_agency.json": 56007,
	"./mo_banker.json": 3165,
	"./mo_broker.json": 59125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79504;